import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { JobForm } from './../forms'
import { Dashboard } from './../layouts'

const styles = theme => ({
    //
})

class JobNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Job'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <JobForm 
                    path="jobs"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(JobNew)
